import React from 'react';
import { Grid } from '@material-ui/core';
import TopicList from './TopicList';
import TopicDealershipList from './TopicDealershipList';
import ShowProgress from '../ui/Backdrop';

export default function TOMMainContent() {
  return (
    <Grid container direction="row">
      <Grid item xs={4}>
        <TopicList />
      </Grid>

      <Grid item xs={7} style={{ marginLeft: '10px' }}>
        <TopicDealershipList />
      </Grid>
      <ShowProgress />
    </Grid>
  );
}
